import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../images/white-logo.png";
import HasPermission from "./HasPermission";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { name: "Dashboard", path: "/admin/dashboard", roles: ["subadmin"] },
    { name: "Categories", path: "/admin/categories", roles: [""] },
    { name: "Banners", path: "/admin/banners", roles: [""] },
    { name: "Products", path: "/admin/products", roles: [""] },
    { name: "Coupons", path: "/admin/coupons", roles: ["subadmin"] },
    { name: "Orders", path: "/admin/orders", roles: ["subadmin"] },
    { name: "Reviews", path: "/admin/reviews", roles: ["subadmin"] },
    { name: "Blogs", path: "/admin/blogs", roles: [""] },
    { name: "Users", path: "/admin/users", roles: [""] },
     { name: "Contacts", path: "/admin/contacts", roles: ["subadmin"] },
  ];

  // Logout Function
  const handleLogout = () => {
    // Yahan aap apna token/auth data clear kar sakte ho
    localStorage.clear(); 
    // Login page par redirect
    navigate("/admin/login"); 
  };

  return (
    <>
      <aside className="adminProSidebar" style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <div className="adminProHeader">
          <img style={{ width: '60%' }} src={logo} alt="logo-sidebar" />
        </div>

        <nav className="adminProMenu" style={{ flexGrow: 1 }}>
          {menuItems.map((item, index) => (
            <HasPermission key={index} allowedRoles={item.roles || []}>
              <Link
                to={item.path}
                className={`adminProLink ${
                  location.pathname === item.path ? "activeAdminPro" : ""
                }`}
              >
                <span className="adminProDot"></span>
                {item.name}
              </Link>
            </HasPermission>
          ))}
        </nav>

        {/* Logout Button Section */}
        <div className="adminProFooter" style={{ padding: '20px', marginTop: 'auto' }}>
          <button 
            onClick={handleLogout} 
            className="adminProLogoutBtn"
            style={{
              width: '100%',
              padding: '10px 15px',
              backgroundColor: '#ff4d4f',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            Logout
          </button>
        </div>
      </aside>
    </>
  );
}